<template>
  <div class="animated fadeIn step-container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 class="text-center">เลือก Plan ของคุณ</h2>
      </div>
      <div class="col-md-8 offset-md-2 step-body">
        <div class="row">
          <div class="col-sm-4" v-for="price in selectedPriceList" :key="price.name" :class="{'margin-top-20': $route.query.app}">
            <div class='pricing'>
              <div class='title'>
                {{price.name}}
              </div>
              <div class='thumbnail'>
                <div class='thumbnail icon'>
                  <img :src="price.image">
                </div>
              </div>
              <div class='content'>
                <div class='sub-title'>
                  {{price.price}}
                  <span>{{price.subPrice}}</span>
                  <p v-html="price.priceDetail"></p>
                </div>
                <ul>
                  <li v-for="feature in price.features" :key="feature.name">
                    <div :class="{'fa': true, 'fa-check': feature.checked, 'fa-close': !feature.checked}"></div>
                    <span v-html="feature.name"></span>
                  </li>
                </ul>
                <router-link :to="price.link + addAppParams" class="sign-up-btn">
                  สมัคร
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  computed: {
    addAppParams () {
      if (this.$route.query.app !== null && this.$route.query.app !== undefined) {
        return '&app=' + this.$route.query.app
      }
      return ''
    }
  },
  data () {
    return {
      selectedPriceList: [],
      // Doctor Price List
      doctorPriceList: [{
        name: '3 เดือน',
        image: '/static/img/plans/plan_1.png',
        link: '/package/payment/step1?plan_id=1',
        price: '฿499',
        priceDetail: '<strong>฿1,497 ต่อ 3 เดือน</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [
          {name: 'มีเลขาส่วนตัวดูแลระบบ', checked: true},
          {name: 'แสดงผลการค้นหาในระบบ', checked: true},
          {name: 'นัดหมายออนไลน์ได้', checked: true},
          {name: 'มีระบบแจ้งเตือนทาง SMS', checked: true},
          {name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true},
          {name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true},
          {name: '<strong>ระยะเวลาสมาชิก 3 เดือน</strong>', checked: true}
        ]
      }, {
        name: '1 ปี',
        image: '/static/img/plans/plan_2.png',
        link: '/package/payment/step1?plan_id=2',
        price: '฿399',
        priceDetail: '<strong>฿4,788 ต่อ 12 เดือน</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [
          {name: 'มีเลขาส่วนตัวดูแลระบบ', checked: true},
          {name: 'แสดงผลการค้นหาในระบบ', checked: true},
          {name: 'นัดหมายออนไลน์ได้', checked: true},
          {name: 'มีระบบแจ้งเตือนทาง SMS', checked: true},
          {name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true},
          {name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true},
          {name: '<strong>ระยะเวลาสมาชิก 12 เดือน</strong>', checked: true}
        ]
      }, {
        name: '3 ปี',
        image: '/static/img/plans/plan_3.png',
        link: '/package/payment/step1?plan_id=3',
        price: '฿299',
        priceDetail: '<strong>฿10,764 ต่อ 36 เดือน</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [
          {name: 'มีเลขาส่วนตัวดูแลระบบ', checked: true},
          {name: 'แสดงผลการค้นหาในระบบ', checked: true},
          {name: 'นัดหมายออนไลน์ได้', checked: true},
          {name: 'มีระบบแจ้งเตือนทาง SMS', checked: true},
          {name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true},
          {name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true},
          {name: '<strong>ระยะเวลาสมาชิก 36 เดือน</strong>', checked: true}
        ]
      }],
      // Clinic Price List
      clinicPriceList: [{
        name: '3 เดือน',
        image: '/static/img/plans/plan_1.png',
        link: '/package/payment/direct?plan_id=1&type=clinic',
        price: '฿1,500',
        priceDetail: '<strong>฿4,500 ต่อ 3 เดือน</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [
          {name: 'แสดงผลการค้นหาในระบบ', checked: true},
          {name: 'นัดหมายออนไลน์ได้', checked: true},
          {name: 'มีระบบแจ้งเตือนทาง SMS', checked: true},
          {name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true},
          {name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true},
          {name: '<strong>ระยะเวลาสมาชิก 3 เดือน</strong>', checked: true}
        ]
      }, {
        name: '1 ปี',
        image: '/static/img/plans/plan_2.png',
        link: '/package/payment/direct?plan_id=2&type=clinic',
        price: '฿1,333',
        priceDetail: '<strong>฿16,000 ต่อ 1 ปี</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [
          {name: 'แสดงผลการค้นหาในระบบ', checked: true},
          {name: 'นัดหมายออนไลน์ได้', checked: true},
          {name: 'มีระบบแจ้งเตือนทาง SMS', checked: true},
          {name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true},
          {name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true},
          {name: '<strong>ระยะเวลาสมาชิก 12 เดือน</strong>', checked: true}
        ]
      }, {
        name: '3 ปี',
        image: '/static/img/plans/plan_3.png',
        link: '/package/payment/direct?plan_id=3&type=clinic',
        price: '฿1,250',
        priceDetail: '<strong>฿45,000 ต่อ 3 ปี</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [
          {name: 'แสดงผลการค้นหาในระบบ', checked: true},
          {name: 'นัดหมายออนไลน์ได้', checked: true},
          {name: 'มีระบบแจ้งเตือนทาง SMS', checked: true},
          {name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true},
          {name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true},
          {name: '<strong>ระยะเวลาสมาชิก 36 เดือน</strong>', checked: true}
        ]
      }]
    }
  },
  mounted () {
    if (this.$route.query.type === 'doctor') {
      this.selectedPriceList = this.doctorPriceList
    } else if (this.$route.query.type === 'clinic') {
      this.selectedPriceList = this.clinicPriceList
    }
  }
}
</script>

<style lang='scss'>
.step-body{
  background-color: #fff;
  padding: 20px;
}
.pricing {
  position: relative;
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin-top: 10px;
  color: #fff;
  background: #fff;
  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}
.pricing .thumbnail .icon {
  background: #eee;
  display: block;
  width: 90px;
  height: 90px;
  margin: 0 auto;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
  font-size: 36px;
  line-height: 90px;
  text-align: center;

  img{
    height: 80%;
  }
}
.pricing .thumbnail {
  background: #eee;
}
.pricing .title {
  cursor: pointer;
  background: #2d3e6f;
  padding: 10px;
  font-size: 24px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
}
.pricing .content {
  padding-bottom: 10px;
  p {
    font-size: 14px;
    font-weight: normal;
  }
}
.pricing .content .sub-title {
  background: #eee;
  padding: 10px;
  color: #666;
  font-size: 2.0rem;
  font-weight: 700;
  text-align: center;
}
.pricing .content .sub-title span {
  background: #eee;
  color: #666;
  font-size: 0.8rem;
  font-weight: 300;
  text-align: center;
}
.pricing .content ul {
  list-style: none;
  background: #fff;
  margin: 0;
  padding: 0;
  color: #666;
  font-size: 0.8rem;
}
.pricing .content ul li {
  padding: 5px 10px;
  font-size: 14px;
}
.pricing .content ul {
  background: #FFFFFF;
}
.pricing .content ul li .fa {
  width: 16px;
  margin-right: 10px;
  text-align: center;
}
.pricing .content ul li .fa-check {
  color: #2ecc71;
}
.pricing .content ul li .fa-close {
  color: #e74c3c;
}
.pricing .content a {
  display: block;
  width: 60%;
  background: #5cb85c;
  margin: 0 auto;
  margin-top: 20px;
  padding: 10px 15px;
  color: #fff;
  border-radius: 16px;
  border: 1px solid #1bbc9d;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
}
.margin-top-20{
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// Package.vue?4e79e9ed